import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseRoundFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM9.27691 7.89805C8.89615 7.51729 8.27881 7.51729 7.89805 7.89805C7.51729 8.27881 7.51729 8.89615 7.89805 9.27691L10.6211 12L7.89805 14.7231C7.51729 15.1038 7.51729 15.7211 7.89805 16.1019C8.27881 16.4827 8.89615 16.4827 9.27691 16.1019L12 13.3788L14.7231 16.1019C15.1038 16.4827 15.7211 16.4827 16.1019 16.1019C16.4827 15.7211 16.4827 15.1038 16.1019 14.7231L13.3788 12L16.1019 9.27691C16.4827 8.89615 16.4827 8.27881 16.1019 7.89805C15.7211 7.51729 15.1038 7.51729 14.7231 7.89805L12 10.6211L9.27691 7.89805Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgCloseRoundFilled);
export default ForwardRef;
